import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillBadge = ({ skill, isHovered }) => {
  const getProficiencyColor = (level) => {
    const colorMap = {
      'Expert': 'bg-green-100 text-green-800 border-green-200',
      'Advanced': 'bg-blue-100 text-blue-800 border-blue-200',
      'Intermediate': 'bg-yellow-100 text-yellow-800 border-yellow-200',
      'Beginner': 'bg-gray-100 text-gray-800 border-gray-200'
    };
    return colorMap[level] || 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const getProficiencyWidth = (level) => {
    const widthMap = {
      'Expert': '100%',
      'Advanced': '80%',
      'Intermediate': '60%',
      'Beginner': '40%'
    };
    return widthMap[level] || '40%';
  };

  const getStarCount = (level) => {
    const starMap = {
      'Expert': 5,
      'Advanced': 4,
      'Intermediate': 3,
      'Beginner': 2
    };
    return starMap[level] || 2;
  };

  return (
    <div className={`p-4 bg-surface rounded-lg border border-border hover:border-primary/30 transition-all duration-300 ${
      isHovered ? 'transform scale-105 shadow-lg' : 'shadow-sm'
    }`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h4 className="font-semibold text-text-primary text-sm mb-1">{skill.name}</h4>
          <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium border ${getProficiencyColor(skill.proficiency)}`}>
            {skill.proficiency}
          </span>
        </div>
        {skill.icon && (
          <div className="ml-2 text-text-secondary">
            <Icon name={skill.icon} size={20} />
          </div>
        )}
      </div>

      {/* Progress Bar */}
      <div className="mb-3">
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-500"
            style={{ width: getProficiencyWidth(skill.proficiency) }}
          />
        </div>
      </div>

      {/* Star Rating */}
      <div className="flex items-center justify-between">
        <div className="flex space-x-1">
          {[...Array(5)].map((_, index) => (
            <Icon
              key={index}
              name="Star"
              size={12}
              className={index < getStarCount(skill.proficiency) 
                ? 'text-yellow-400 fill-current' :'text-gray-300'
              }
            />
          ))}
        </div>
        <span className="text-xs text-text-secondary">
          {skill.experience}
        </span>
      </div>

      {/* Hover Details */}
      {isHovered && skill.description && (
        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-xs text-text-secondary leading-relaxed">
            {skill.description}
          </p>
          {skill.certifications && skill.certifications.length > 0 && (
            <div className="mt-2">
              <div className="flex items-center space-x-1 mb-1">
                <Icon name="Award" size={12} className="text-accent" />
                <span className="text-xs font-medium text-text-primary">Certifications:</span>
              </div>
              <div className="flex flex-wrap gap-1">
                {skill.certifications.map((cert, index) => (
                  <span key={index} className="text-xs bg-accent/10 text-accent px-2 py-1 rounded">
                    {cert}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SkillBadge;